var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.85 62.52",
    style: {
      enableBackground: "new 0 0 63.85 62.52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000023989641358008366890000008035705767765382302_);}\n\t.st3{clip-path:url(#SVGID_00000062893527839706643960000004531142491179677577_);}\n\t.st4{clip-path:url(#SVGID_00000070086555621252041520000009305168607961461644_);fill:#55BBB1;}\n\t.st5{clip-path:url(#SVGID_00000058577877929254192000000016933051400316288691_);}\n\t.st6{clip-path:url(#SVGID_00000013888202960385092900000018436811058751843002_);fill:#55BBB1;}\n\t.st7{clip-path:url(#SVGID_00000039831541154096335780000010404598796849479342_);}\n\t.st8{clip-path:url(#SVGID_00000121252365626503970730000014683483179277112988_);fill:#55BBB1;}\n\t.st9{clip-path:url(#SVGID_00000019642340513751976080000000614507372131758255_);}\n\t.st10{clip-path:url(#SVGID_00000031167039472471794520000013603515011571957632_);fill:#55BBB1;}\n\t.st11{clip-path:url(#SVGID_00000016774294941337697970000006750446389439159207_);}\n\t.st12{clip-path:url(#SVGID_00000153664301031756656470000015407302344744810409_);fill:#55BBB1;}\n\t.st13{clip-path:url(#SVGID_00000003088374471969985970000002551383349290540208_);}\n\t.st14{clip-path:url(#SVGID_00000178924918617969177130000008342417831355557035_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 72,
    height: 71,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABICAYAAAC6L9h5AAAACXBIWXMAAAsSAAALEgHS3X78AAAG O0lEQVR4nO1cTdakNhArOnOnLHKnHCZ3yiKHmq+zGecVQlKVjemZRfQeDzDGP0KuKhu6j2jgz3/+ Pjr5fib++v2P91Nly84XxKhru8l0HZfXdhN26ZQg52gcfwLvxnFE7CXq1ElCECPk04RVxEiydhH1 X8cMQWxfEbYTihhMZ6RtIeol0pGQsb1+bAfsf9ZWPbgtTucbKUgRhA2RDXsIqBbccr4jvNGfwjc4 rwjKCsr58P6dwGHECPoi92wj6iAqcsS8QqvoUzaJEZT3VGF3bFNWEjPczPao4XcHowOqHKWirx9t ynt17zLYcFNK6qipA9bo6v5xnakkE7TVFg0gSblRiqAZkipCZjs0SEBjPQhCG7lazwmDJOXFMiFM TbnxrGFOIR3j2lEY27aqiSmp8nDo3RRmniim5+GlgtyIc5w38m4nqhpu+XinsWaGGK+r2E3lY23O dS0jPwkVMKprFVzAp64rN06nHKatF9yJvJ2ScuVdUsY91RKH21SgimUfKb9S/ZYhp0gaFbrzDLts Qa6piDkTlQlAxXfam9O3eLdcID7BLjkd5M6r6Uannqyc7XERIocADDPxj0OnM0gaI7Iyxo+oyQ23 XVAGtVJDtk+oPkfWHa9LcZek2UZWQ0x5MZXG8mwffmrRTTUgN4TNzvE4oiayevKMuCrO2ooZkiJ0 rMOudxqOZHUIU2p7jKgnbRLaIiQgL3FE8GWOmfjsMcwqaRWMKBUE4hq2mhZh2a7eiFiPuj/h3RDo sbKilH1R06K3yJMj7pP3HETNrFTuVlL1VN2kOSvJKYgpidWr5qERMaequyR1glAWwVdbtUzM0lV+ SXCXqCds0ox7z/k6HVeEd/LTMjpE3SXJLX+w8wqdDndViKuqUlUVUU96NxZsujWmOwSxt8pjn49z +blOS9QuklTErVTVDTRXicIQovWmRxG1OwRgk1I8znkRmIcZbAcMUAduvZf7VDA5i8qjoYLYhxQq zXk/qqYdSuoaZVRWBlOIUhFTZE7L0xynKFTWQdp1KnAFbhXRrQg8YY+Yun4LrTIVJkTEVU27bBLz UisLYjgMMI2VMRQw9nnd3IlgvPVFXNq9SpJbl65WGTMOcsxshsrrymZG/J3O3ymPVfcKSdUiGGJ0 NHdGebEqrXvvQP6Q4oDzV0R8j/ODGDj1Y0fEneWdj3HDPG7Gj8fdEKDj/VhsdSk326U7w01NPXAv DWS6jsdqyGF+1i5VRybmHbxcOux2vQioPBp7upUqInhHKnuEaax+tl3WngZmSXJr3OrYeRBmq5jy urYMPStTJCvbErUrmMQhlz0GKih3Qg0Pho5dwgeDne7auBNRs4Zb2ZWMSm0szyh7pp4ZKOVgvRQ7 ViaVgZ0pY+Y8o71O3WwHrWuVpFXv48qYxQ6CWvWijZgt2B3fVVinHXfLZQHxBcxwMxvCkL2BU4SK fVawel9n6iTTkaSZxbGcF9+d4TfVKjaZRdcbqvmjC4IlXAjAAsIMPM8vF484N6CKUbBejFlssGfa rDxrNe+UcRLrHMZAHU/E4qYqoEOwqLkLpxY1d7S2yQ03JkWMjp388al3jTlTDAaH6j61Z+TYH+xk OMOtCnCdQDhDjnXm60o53eHG2u4+f7ZKHSSxcD4XPoALWRUJWLlyCtj5roFG4MNUxGD65f78QQUb brnRinG19NnphEpnIQWmd8pnhLC1rbaalHdjsh2KUoa3MrSOoHy/8oBoD1V7I+oFQKakFkmqY4Mc XArFzlQkdNLVRJQRxspjQ00R8xVXgmhbj4jTUiVrkHpF3J2zWaMo2uQIquphZCBhyi5d7FGEt0nj HH+ZyBqf964D6hzLqeIq5SGdTUJ1LQ031okhbUdQpaYZ+1QRNEsSIyUfX9rDPhN8kQvMaDsj+B2O ccO8mObKU2WqTZWBisI+WjglOQOJBnQ2HHBKwn01vJnxrbYIQpD62PTUueIfb9SwWomXIq5EYZmK MFUnI8AR0yKIVma++KqImSGrUlI+rshh5VbEtAmylTY+uFxVUAVFlLqm7GlOo0Y6ovc9d7ujH/zL su6wdhG+IuuE7gfvn+p4icY/gLFzBktMxPz/lvwyJA0s/pfcgO386p+6/HIkIe4M8yf/MfB/AP4F UZM+kKqDPSAAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 -4.5181 -4.6385)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -4.52,
    y: -4.64,
    className: "st0",
    width: 72,
    height: 71
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8.01,
    y: 5.76,
    width: 52,
    height: 51
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107579502551318706120000005199864622904341682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000137831861348866018980000006527253183333890448_",
    d: "M41.2,5.76H13.06c-2.79,0-5.05,2.26-5.05,5.04v37.61 c0,2.78,2.26,5.04,5.05,5.04h17.13c0.83,0,1.51-0.68,1.51-1.5s-0.68-1.5-1.51-1.5H13.06c-1.13,0-2.04-0.9-2.04-2.03V10.8 c0-1.13,0.91-2.03,2.04-2.03H41.2c1.13,0,2.04,0.9,2.04,2.03v14.14c0,0.83,0.68,1.5,1.51,1.5c0.83,0,1.51-0.68,1.51-1.5l0-14.22 C46.26,7.94,43.99,5.76,41.2,5.76L41.2,5.76z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065758920568870094490000003284020631206506160_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137831861348866018980000006527253183333890448_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065758920568870094490000003284020631206506160_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101076507696265881700000016549962339390216885_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111875361150802301200000014076237010532951997_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101076507696265881700000016549962339390216885_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.01,
    y: 4.76,
    style: {
      clipPath: "url(#SVGID_00000111875361150802301200000014076237010532951997_)",
      fill: "#55BBB1"
    },
    width: 40.25,
    height: 49.69
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119831585087636617070000017231939653358495909_",
    d: "M17.82,18.17H28.6c0.83,0,1.51-0.68,1.51-1.5 c0-0.83-0.68-1.5-1.51-1.5H17.82c-0.83,0-1.51,0.68-1.51,1.5C16.31,17.5,16.99,18.17,17.82,18.17z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121237032353421284660000005190157147026220977_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119831585087636617070000017231939653358495909_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121237032353421284660000005190157147026220977_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155108356762182218360000017643571466894555067_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041275915850720863570000003793789886913604287_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155108356762182218360000017643571466894555067_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.31,
    y: 14.16,
    style: {
      clipPath: "url(#SVGID_00000041275915850720863570000003793789886913604287_)",
      fill: "#55BBB1"
    },
    width: 15.81,
    height: 5.01
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146500484991376571770000010723797381341803678_",
    d: "M37.73,24.94c0-0.83-0.68-1.5-1.51-1.5H17.82 c-0.83,0-1.51,0.68-1.51,1.5c0,0.83,0.68,1.5,1.51,1.5h18.33C37.05,26.45,37.73,25.77,37.73,24.94L37.73,24.94z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183933899869393744520000013969606534583370405_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146500484991376571770000010723797381341803678_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183933899869393744520000013969606534583370405_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000133498337356126126850000005321368753318048174_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030472349707919966040000008317412341259590310_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133498337356126126850000005321368753318048174_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.31,
    y: 22.44,
    style: {
      clipPath: "url(#SVGID_00000030472349707919966040000008317412341259590310_)",
      fill: "#55BBB1"
    },
    width: 23.43,
    height: 5.01
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000081629287466190028440000005515244977779009152_",
    d: "M17.82,32.47c-0.83,0-1.51,0.68-1.51,1.5 s0.68,1.5,1.51,1.5h11.54c0.83,0,1.51-0.68,1.51-1.5s-0.68-1.5-1.51-1.5H17.82z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154391280109638326370000014296891836559294898_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081629287466190028440000005515244977779009152_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154391280109638326370000014296891836559294898_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132790522476732043160000008407852680414558631_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135661548364246391820000001943756149170889395_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132790522476732043160000008407852680414558631_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.31,
    y: 31.47,
    style: {
      clipPath: "url(#SVGID_00000135661548364246391820000001943756149170889395_)",
      fill: "#55BBB1"
    },
    width: 16.56,
    height: 5.01
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013890436736997071260000015044151623015610759_",
    d: "M45.28,32.39c5.88,0,10.71,4.81,10.71,10.68 c0,5.87-4.83,10.68-10.71,10.68c-5.88,0-10.71-4.81-10.71-10.68C34.56,37.2,39.32,32.39,45.28,32.39z M45.28,56.76 c7.54,0,13.73-6.17,13.73-13.69c0-7.52-6.19-13.69-13.73-13.69s-13.73,6.17-13.73,13.69C31.55,50.59,37.66,56.76,45.28,56.76z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046332066979541990360000008380210586442443916_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013890436736997071260000015044151623015610759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046332066979541990360000008380210586442443916_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000086669325955513830540000003873183795702523286_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014625641820874017810000000562388986223740590_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086669325955513830540000003873183795702523286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.55,
    y: 28.38,
    style: {
      clipPath: "url(#SVGID_00000014625641820874017810000000562388986223740590_)",
      fill: "#55BBB1"
    },
    width: 29.46,
    height: 29.38
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107579502551318706120000005199864622904341682_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003808254446408395290000004878367960433797027_",
    d: "M39.32,44.58h4.45v4.44c0,0.83,0.68,1.5,1.51,1.5 c0.83,0,1.51-0.68,1.51-1.5v-4.44h4.45c0.83,0,1.51-0.68,1.51-1.5c0-0.83-0.68-1.5-1.51-1.5h-4.45v-4.44 c0-0.83-0.68-1.5-1.51-1.5c-0.83,0-1.51,0.68-1.51,1.5v4.44h-4.45c-0.83,0-1.51,0.68-1.51,1.5 C37.81,43.9,38.49,44.58,39.32,44.58z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040563888253003302900000008635234625473355158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003808254446408395290000004878367960433797027_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040563888253003302900000008635234625473355158_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106857549375749163040000016491837909495565185_",
    x: -1.99,
    y: -4.24,
    width: 71,
    height: 71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152222072212797329300000010421374321622422703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106857549375749163040000016491837909495565185_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.81,
    y: 34.62,
    style: {
      clipPath: "url(#SVGID_00000152222072212797329300000010421374321622422703_)",
      fill: "#55BBB1"
    },
    width: 16.94,
    height: 16.89
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.620ec1d5a9d6620d890c873ff4e09a0c.svg";
export { ForwardRef as ReactComponent };